import { graphql } from '@apollo/client/react/hoc'

import get from 'lodash/get'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { filterNullsFromItems } from '../../helpers/transforms'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ centre }) => ({
  errorPolicy: 'ignore',
  context: { version: 2 },
  variables: {
    centreId: centre.sys.id,
  },
})

export const mapDataToProps = ({
  data: { error, loading, cfCentre },
  ownProps,
}) => {
  // https://github.com/ScentreGroup/cxt-architecture/pull/31
  const centre = filterNullsFromItems(cfCentre)
  const parkingTemplate = get(centre, [
    'linkedFrom',
    'parkingTemplateCollection',
    'items',
    0,
  ])
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!parkingTemplate) {
    return {
      error: new NotFoundError(),
    }
  }
  return {
    ...ownProps,
    parkingTemplate,
    parkingModules: get(parkingTemplate, ['modulesCollection', 'items']),
  }
}

const withParkingModules = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withParkingModules
